import {Injectable} from '@angular/core';
import {IQuestionDef} from '@app/services/metas/meta-surveys-infos.objects';
import {IACategory, ICategories} from '@app/components/projects/surveys/annotation/store/annotations.entitiy';

@Injectable({
  providedIn: 'root'
})
export class AnnotationsUpdateV2Service {


  constructor() {
  }

  wordNewFormat(word: string): string {
    word = word?.trim() || '';
    word = word.charAt(0).toUpperCase() + word.slice(1);
    word = word.replace(/[#$.\[\]]/g, '-').replace(/\//g, '\\');
    return word;
  }

  updateCategories(categories: any): Record<string, ICategories> {
    const extractTree = (oneSet: any, root?: boolean): Record<string, IACategory> => {
      return oneSet.reduce((acc: any, c: any) => ({
        ...acc,
        [c.id]: {
          id: c.id,
          pId: c.pid,
          label: c.name,
          childIndex: c.child.map((child: any) => child.id),
          ref: c.created ? null : c.id
        },
        ...((c.child?.length) ? extractTree(c.child) : {})
      }), (root) ? {
        mainRootxyz: {
          id: 'mainRootxyz',
          pId: null,
          label: 'Main Root',
          childIndex: oneSet.map((t: any) => t.id),
          ref: null
        }
      } : {});
    };

    return categories.reduce((obj: Record<string, ICategories>, q: any) => {
      if (!q.tree.length) {
        return obj;
      }
      if (q.columnId === -1 && q.lineId === -1) {
        obj[q.key] = {...obj[q.key], question: extractTree(q.tree, true)};
      } else if (q.mode !== 'matrix' && typeof q.lineId === 'string') {
        obj[q.key] = {
          ...obj[q.key],
          statement: {...obj[q.key]?.statement, [q.lineId]: extractTree(q.tree, true)}
        };
      } else if (q.mode === 'matrix') {
        if (typeof q.columnId === 'string' && typeof q.lineId !== 'string') {
          obj[q.key] = {
            ...obj[q.key],
            row: {...obj[q.key]?.row, [q.columnId]: extractTree(q.tree, true)}
          };
        } else if (q.lineId === -2 && q.columnId === -1) {
          obj[q.key] = {
            ...obj[q.key],
            statement: {...obj[q.key]?.cell, [q.statementId]: extractTree(q.tree, true)}
          };
        } else if (typeof q.columnId === 'string' && typeof q.lineId === 'string') {
          obj[q.key] = {
            ...obj[q.key],
            cell: {
              ...obj[q.key]?.cell,
              [q.columnId]: {...obj[q.key]?.cell?.[q.columnId], [q.lineId]: extractTree(q.tree, true)}
            }
          };
        }
      }
      return obj;
    }, {});
  }

  buildNewFormatFrom2022(responses: any, questions: Array<IQuestionDef>) {
    const dico = {};
    const newData = Object.fromEntries(responses.reduce((arr, r: any) => {
      const newFormat = questions.reduce((accQ, question) => {
        dico[question.key] ??= {};
        const newRow = Object.entries(r.raw_result[question.key] || {})
          .reduce((accR, [rKey, row]) => {
            return ((row as any).comments) ? {
              ...accR, [rKey]: {
                ...r.raw_result[question.key][rKey],
                annotations: Object.keys((row as any).comments || {})
                  .reduce((accV, sKey) => {
                    if (!(row as any).comments[sKey]) {
                      return accV;
                    }
                    const annoKeys = ((row as any).annotations as any)?.[sKey]?.annotations?.all?.map((anno: any) => {
                      const annoKey = this.wordNewFormat(anno);
                      if (annoKey.length) {
                        dico[question.key][annoKey] ??= {key: annoKey, label: anno};
                        return annoKey;
                      }
                    }).filter(Boolean) || [];
                    const s = ((row as any).annotations as any) as any;
                    return {...accV, [sKey]: {locked: s?.locked, star: s?.star, sentiment: s?.sentiment, annoKeys}};
                  }, {})
              }
            } : accR;
          }, {});
        return Object.keys(newRow || {}).length ? {...accQ, [question.key]: newRow} : accQ;
      }, {});
      return Object.keys(newFormat || {}).length ? arr.concat([[r.user_id, newFormat]]) : arr;
    }, []));
    return {dico, newData};
  }

  buildNewFormatFromOld(responses: any, arrayQuestions: Array<IQuestionDef>) {
    const dico = {};
    const newData = {};
    const questions = Object.fromEntries(arrayQuestions.map(q => [q.key, q]));
    Object.entries(responses.responsesByQuestionId).forEach(([qId, response]) => {
      const setResponse = (resp: Array<any>, qKey: string, rKey: string, sKey: string) => {
        resp.forEach((r: any) => {
          const annoKeys = r.annotations.all?.map((anno: string) => {
            const annoKey = this.wordNewFormat(anno);
            dico[qKey][annoKey] ??= {key: annoKey, label: anno};
            return annoKey;
          });
          if (annoKeys.length) {
            newData[r.userId] ??= {};
            newData[r.userId][qKey] ??= {};
            newData[r.userId][qKey][rKey] ??= {annotations: {}};
            newData[r.userId][qKey][rKey].annotations[sKey] = {locked: r.locked, star: r.star, sentiment: r.sentiment, annoKeys};
          }

        }, {});
      };

      const question = questions[`k_${qId}`] || questions[arrayQuestions.find(q => q.type === 'matrix' && q.rows[`r_${qId}`])?.key];
      if (question) {
        dico[question.key] ??= {};
        if (question.type === 'open') {
          setResponse(response[-1], question.key, question.rowsOrder[0], question.statementsOrder[0]);
        } else if (question.type !== 'matrix') {
          Object.keys(response).forEach(sId => {
            if (sId !== 'statementsIndex') {
              setResponse(response[sId], question.key, question.rowsOrder[0], `s_${sId}`);
            }
          });
        } else {
          Object.keys(question.rowsOrder).forEach(rKey => {
            const rId = +rKey.split('_')?.[1];
            Object.keys(response[rId] || {}).forEach(sId => {
              if (sId !== 'statementsIndex') {
                setResponse(response[rId][sId], question.key, `r_${rId}`, `s_${sId}`);
              }
            });
          });
        }
      }
    });
    return {newData, dico};
  }

}
